import { Badge } from "@/components/ui/badge"

export type AgencySettings = {
  readonly name: string
  readonly slug: string
  readonly classifier_model: string
  readonly draft_model: string
  readonly daily_ai_budget_usd: number
  readonly actions_armed: boolean
  readonly smartlead_api_key_set: boolean
  readonly openrouter_api_key_set: boolean
}

export function ReadOnlySettings({ agency }: { readonly agency: AgencySettings }) {
  return (
    <section className="mt-8 rounded-lg border border-hairline bg-page p-6">
      <div className="mb-6 rounded-md border border-hairline bg-surface px-4 py-3">
        <p>Only admins can change agency settings.</p>
      </div>

      <dl className="grid gap-5 sm:grid-cols-2">
        <SummaryItem label="Agency" value={`${agency.name} (${agency.slug})`} />
        <SummaryItem label="Classifier model" value={agency.classifier_model || "Not set"} />
        <SummaryItem label="Draft model" value={agency.draft_model || "Not set"} />
        <SummaryItem label="Daily AI budget USD" value={`$${agency.daily_ai_budget_usd}`} />
        <SummaryItem label="SmartLead API key" value={agency.smartlead_api_key_set ? "Set" : "Not set"} />
        <SummaryItem label="OpenRouter API key" value={agency.openrouter_api_key_set ? "Set" : "Not set"} />
        <div className="space-y-2">
          <dt className="text-sm text-ink-muted">Actions</dt>
          <dd>
            <Badge
              tone={agency.actions_armed ? "neutral" : "signal"}
              className={agency.actions_armed ? "border-danger bg-danger-faded text-danger-display" : undefined}
            >
              {agency.actions_armed ? "ARMED · live actions" : "DISARMED · dry-run only"}
            </Badge>
          </dd>
        </div>
      </dl>
    </section>
  )
}

function SummaryItem({
  label,
  value,
}: {
  readonly label: string
  readonly value: string
}) {
  return (
    <div className="space-y-2">
      <dt className="text-sm text-ink-muted">{label}</dt>
      <dd className="text-ink-display">{value}</dd>
    </div>
  )
}
